$(document).ready(function() {
    $('.usp-item').on('click', function() {
        let postUrl = $(this).attr('data-posturl');
        if(postUrl != '') {
            location.href = postUrl;
        }
        else {
            return false;
        }
    });
});